import {toast} from "react-toastify";

export default function request(type, path, method, payload, query, sort, isCache) {
    return async (dispatch, store) => {
        const { user } = store();

        const hasBody = (method !== "GET");

        const queryString =
            query &&
            query.map(param => `"${Object.keys(param)[0]}":${Object.values(param)[0]}`);

        let suffix = path;

        if (!hasBody) {
            if (!isCache) {
                suffix += '?t=' + Date.now()
            } else {
                suffix += '?'
            }
        }

        if (query && queryString.length) {
            suffix = `${suffix}&where={${queryString}}`
        }

        if (sort && sort.length) {
            suffix = suffix + "&sort=" + sort
        }

        const url = `${process.env.REACT_APP_API_SERVER}${suffix}`;
        const body = hasBody ? JSON.stringify(payload) : undefined;

        const headers = {
            Authorization: user.token,
            "Content-Type": "application/json"
        };

        dispatch({
            type,
            url,
            payload,
            query,
            isLoading: true
        });

        return window
            .fetch(url, {
                method,
                body,
                headers: new window.Headers(headers),
                mode: "cors",
                cache: "default",
                redirect: "follow"
            })
            .then(res => {
                if(res.status === 401 && url.includes("/login")){
                    toast.error("The username and/or password combination is not valid.", {position: toast.POSITION.TOP_CENTER});
                    return;
                }
                if (res.status === 401 && localStorage.getItem("timocco.auth")) {
                    
                    localStorage.removeItem("timocco.auth");
                    window.location = "/";
                }

                return res.json().then(
                    body => {
                        if (body.new_auth) {
                            console.log("new auth token:" + body.new_auth);
                            localStorage.setItem("timocco.auth", body.new_auth);
                        }
                        return dispatch({
                            type,
                            body,
                            payload,
                            query,
                            url: res.url,
                            status: res.status,
                            headers: res.headers,
                            ok: res.ok,
                            isLoading: false
                        });
                    },
                    error => {
                        return dispatch({
                            type,
                            error,
                            payload,
                            query,
                            url: res.url,
                            status: res.status,
                            headers: res.headers,
                            parseError: true,
                            isLoading: false
                        });
                    }
                );
            })
            .catch(error => {
                return dispatch({
                    type,
                    error,
                    url,
                    payload,
                    query,
                    failed: true,
                    isLoading: false
                });
            });
    };
}



// WEBPACK FOOTER //
// ./src/modules/api/api.js